function decodeEntity(inputStr) {
  var textarea = document.createElement("textarea");
  textarea.innerHTML = inputStr;
  return textarea.value;
}

(async () => {
  if (!window.mapkit || window.mapkit.loadedLibraries.length === 0) {
    // mapkit.core.js or the libraries are not loaded yet.
    // Set up the callback and wait for it to be called.
    await new Promise((resolve) => {
      window.initMapKit = resolve;
    });

    // Clean up
    delete window.initMapKit;
  }

  var position, zip;
  // https://maps.developer.apple.com/token-maker
  const tokenID =
    "eyJhbGciOiJFUzI1NiIsInR5cCI6IkpXVCIsImtpZCI6Ik45WjI2Tjg1VVQifQ.eyJpc3MiOiI0TUVIMzM0OFZLIiwiaWF0IjoxNjc2NjY0NDExLCJleHAiOjE3MDgwNDE2MDAsIm9yaWdpbiI6Imh0dHBzOi8vYnJheHRvbmJyZXdpbmcuY29tIn0.FuqjH3kBArgsW-FXPBsJQVhi2i9FnRU_ug0uuhfZWxb6Y7F91STEZuPEXvXBrZAxQORjKd1w5TUh5rnW3UfiBQ";

  mapkit.init({
    authorizationCallback: function (done) {
      done(tokenID);
    },
  });

  let map = new mapkit.Map("map", {});

  var markers = [];
  var template = $("#sidebar-location-template").html();
  Mustache.parse(template);

  // API only manages exact string matches, this map helps users search
  // for what they mean.
  var brandMap = {
    storm: "storm golden cream ale",
    "storm ale": "storm golden cream ale",
    "storm cream ale": "storm golden cream ale",
    "cream ale": "storm golden cream ale",
    "storm golden": "storm golden cream ale",
    "golden cream ale": "storm golden cream ale",
    "garage beer premium lager": "garage beer",
    "garage beer lager": "garage beer",
    garage: "garage beer",
    "garage lager": "garage beer",
    lager: "garage beer",
    "tropic flare": "tropic flare: new england",
    "tropic flare hazy ipa": "tropic flare: new england",
    "tropic flare ipa": "tropic flare: new england",
    "hazy ipa": "tropic flare: new england",
    "new england ipa": "tropic flare: new england",
    "ne ipa": "tropic flare: new england",
    tropic: "tropic flare: new england",
    flare: "tropic flare: new england",
    haven: "haven hefewizen",
    hefeweizen: "haven hefewizen",
    "haven wheat beer": "haven hefewizen",
    "german wheat beer": "haven hefewizen",
    "wheat beer": "haven hefewizen",
    "haven hefe": "haven hefewizen",
    "summer trip": "summertrip",
    "summertrip berliner weisse": "summertrip",
    "summer trip berliner weisse": "summertrip",
    "berliner weisse": "summertrip",
    "passionfruit berliner": "summertrip",
    "passionfruit berliner weisse": "summertrip",
    "winter trip": "wintertrip",
    "wintertrip berliner weisse": "wintertrip",
    "winter trip berliner weisse": "wintertrip",
    "pineapple berliner": "wintertrip",
    "pineapple berliner weisse": "wintertrip",
    "oktober fuel": "oktoberfuel",
    "oktober fuel lager": "oktoberfuel",
    "oktober fuel oktoberfest lager": "oktoberfuel",
    "oktoberfuel oktoberfest lager": "oktoberfuel",
    oktoberfest: "oktoberfuel",
    "oktoberfest lager": "oktoberfuel",
    fuel: "oktoberfuel",
    "jam session: session ipa": "jam session: session ipa",
    "jam session": "jam session: session ipa",
    "jam session ipa": "jam session: session ipa",
    "jam session pale ale": "jam session: session ipa",
    "session ipa": "jam session: session ipa",
    "session pale ale": "jam session: session ipa",
    "jam session summer session ipa": "jam session: session ipa",
    "summer session ipa": "jam session: session ipa",
    "graeter's pumpkin pie ale": "graeter s: pumpkin pie",
    "graeter's pumpkin": "graeter s: pumpkin pie",
    "graeter's pumpkin ale": "graeter s: pumpkin pie",
    "graeters pumpkin pie ale": "graeter s: pumpkin pie",
    "graeters pumpkin": "graeter s: pumpkin pie",
    "graeters pumpkin ale": "graeter s: pumpkin pie",
    "pumpkin pie ale": "graeter s: pumpkin pie",
    "pumpkin pie": "graeter s: pumpkin pie",
    "pumpkin ale": "graeter s: pumpkin pie",
    "graeter's": "graeter s: pumpkin pie",
    "graeter's pumpkin ale": "graeter s: pumpkin pie",
    "graeter's ice cream": "graeter s: pumpkin pie",
    "graeter's key lime pie ale": "graeter s: key lime pie",
    "graeter's key lime": "graeter s: key lime pie",
    "graeter's key lime ale": "graeter s: key lime pie",
    "graeters pumpkin ale": "graeter s: pumpkin pie",
    "graeters ice cream": "graeter s: pumpkin pie",
    "graeters key lime pie ale": "graeter s: key lime pie",
    "graeters key lime": "graeter s: key lime pie",
    "graeters key lime ale": "graeter s: key lime pie",
    "key lime pie": "graeter s: key lime pie",
    "key lime pie ale": "graeter s: key lime pie",
    "key lime ale": "graeter s: key lime pie",
    "cucumber witbier": "braxton labs: cucumber wi",
    "braxton labs cucumber": "braxton labs: cucumber wi",
    "braxton labs cucumber wit": "braxton labs: cucumber wi",
    "braxton labs cucumber witbier": "braxton labs: cucumber wi",
    "cucumber wit": "braxton labs: cucumber wi",
    "braxton labs wit": "braxton labs: cucumber wi",
    "bavarian lager": "bavarian style select lag",
    "bavarian select lager": "bavarian style select lag",
    bavarian: "bavarian style select lag",
    "vive tailgate variety pack": "vive: tailgate pack - ben",
    "tailgate variety pack": "vive: tailgate pack - ben",
    "bengals variety pack": "vive: tailgate pack - ben",
    "tailgate pack": "vive: tailgate pack - ben",
    vive: "vive: variety pack",
    "vive pack": "vive: variety pack",
    "variety pack": "vive: variety pack",
    "vive variety": "vive: variety pack",
    "vive variety pack": "vive: variety pack",
    "vive mango": "vive: mango",
    mango: "vive: mango",
    "vive hard seltzer mango": "vive: mango",
    "vive lime": "vive: lime",
    lime: "vive: lime",
    "vive hard seltzer lime": "vive: lime",
    "vive dragonfruit": "vive: dragonfruit",
    dragonfruit: "vive: dragonfruit",
    "vive hard seltzer dragonfruit": "vive: dragonfruit",
    "vive blood orange": "vive: blood orange",
    "blood orange": "vive: blood orange",
    "vive hard seltzer blood orange": "vive: blood orange",
    "bengals blood orange": "vive: blood orange",
    "bengals vive": "vive: blood orange",
    "braxton labs strawberry gose": "braxton labs: strawberry",
    "braxton labs gose": "braxton labs: strawberry",
    "braxton labs strawberry": "braxton labs: strawberry",
    "strawberry gose": "braxton labs: strawberry",
    "strawberry sour": "braxton labs: strawberry",
    "pride watermelon wheat": "pride - watermelon wheat",
    pride: "pride - watermelon wheat",
    "watermelon wheat": "pride - watermelon wheat",
    "pride wheat": "pride - watermelon wheat",
    "pride watermelon": "pride - watermelon wheat",
    "kickback rose": "kickback rose",
    "kickback cider": "kickback rose",
    "kickback rose hard cider": "kickback rose",
    "rose hard cider": "kickback rose",
    kickback: "kickback cider",
    "kickback hard cider": "kickback cider",
    "hard cider": "kickback cider",
    cider: "kickback cider",
    1957: "1957 english mild ale",
    "english mild ale": "1957 english mild ale",
    "english style mild ale": "1957 english mild ale",
    "english style ale": "1957 english mild ale",
    "1957 english style ale": "1957 english mild ale",
    "1957 english style mild ale": "1957 english mild ale",
    "1957 ale": "1957 english mild ale",
    "all star ale": "1957 english mild ale",
    "1957 all star ale": "1957 english mild ale",
    "variety pack - 2019: q1": "variety pack - 2019: Q1",
    "braxton variety pack": "variety pack - 2019: Q1",
    "beer variety": "variety pack - 2019: Q1",
    "beer variety pack": "variety pack - 2019: Q1",
    "variety beer": "variety pack - 2019: Q1",
    "braxton variety": "variety pack - 2019: Q1",
    "variety pack beer": "variety pack - 2019: Q1",
    "beer pack": "variety pack - 2019: Q1",
    "12 pack beer": "variety pack - 2019: Q1",
  };

  var beerMap = {
    "storm golden cream ale": "Storm",
    "tropic flare: new england": "Tropic Flare",
    "haven hefewizen": "Haven",
    oktoberfuel: "Oktober Fuel",
    "jam session: session ipa": "Jam Session",
    "graeter s: pumpkin pie": "Graeter’s Pumpkin Pie Ale",
    "graeter s: key lime pie": "Graeter’s Key Lime Pie Ale",
    "braxton labs: cucumber wi": "Cucumber Witbier",
    "bavarian style select lag": "Bavarian Lager",
    "vive: tailgate pack - ben": "VIVE Tailgate Variety Pack",
    "vive: variety pack": "VIVE Variety Pack",
    "vive: mango": "VIVE Mango",
    "vive: lime": "VIVE Lime",
    "vive: dragonfruit": "VIVE Dragonfruit",
    "vive: blood orange": "VIVE Blood Orange",
    "braxton labs: strawberry": "Strawberry Gose",
    "pride - watermelon wheat": "Pride Watermelon Wheat",
    "kickback - rose": "Kickback Rose",
    "1957 english mild ale": "1957",
    "variety pack - 2019: q1": "Braxton Variety Pack",
  };

  function getParameterByName(name) {
    var match = RegExp("[?&]" + name + "=([^&]*)").exec(window.location.search);
    return match && decodeURIComponent(match[1].replace(/\+/g, " "));
  }

  function renderSidebar(locations) {
    var $sidebar = $.map(locations, function (loc, i) {
      var phone = loc.phone.replace(/(\d{3})(\d{3})(\d{4})/, "($1) $2-$3");
      var phoneHref = loc.phone.replace(
        /(\d{3})(\d{3})(\d{4})/,
        "tel:$1-$2-$3"
      );
      var beers = loc.beers.map(function (beer) {
        return beerMap[beer.name.toLowerCase()] || beer.name;
      });
      var fullAddress = encodeURIComponent(
        loc.name +
          " " +
          loc.street +
          " " +
          loc.city +
          ", " +
          loc.state +
          " " +
          loc.zip
      );

      var locationData = {
        index: i.toString(),
        number: (i + 1).toString(),
        name: loc.name,
        street: loc.street,
        city: loc.city,
        state: loc.state,
        zip: loc.zip,
        phoneHref: phoneHref,
        phone: phone,
        beers: beers,
        fullAddress: fullAddress,
      };

      var rendered = Mustache.render(template, locationData);
      var $html = $(rendered);
      $html.data("index", i);
      $html.data("location", loc);

      return $html;
    });

    // Render sidebar with location markup
    $("#locations-list").html($sidebar);
  }

  function search(options) {
    // Clear existing markers from map
    map.removeAnnotations(map.annotations);

    // Clear existing sidebar items
    renderSidebar([]);

    // Hide no results pane
    $("#beer-finder-no-results").css({ display: "none" });

    // Show loading panew
    $("#beer-finder-loading").css({ display: "flex" });

    var xhr = $.ajax({
      url: "https://braxton-queue.herokuapp.com/api/locations",
      type: "get",
      data: options,
    });

    xhr.done(function (data) {
      if (data.length === 0) {
        $("#beer-finder-no-results").css({ display: "flex" });
        return;
      }

      renderSidebar(data);

      var factory = function (coordinate, options) {
        var div = document.createElement("div"),
          title = options.title, // "John Appleseed"
          index = options.index; // "0"

        div.textContent = index;
        div.className = "marker--default";

        return div;
      };

      data.forEach(function (location, index) {
        const center = new mapkit.Coordinate(location.lat, location.long);

        const options = {
          index: (index + 1).toString(),
          displayPriority: 1000 - index,
          title: decodeEntity(location.name),
          subtitle: location.city + ", " + location.state,
          data: {
            locationId: index,
          },
        };
        const annotation = new mapkit.Annotation(center, factory, options);

        annotation.addEventListener(
          "select",
          function (event, object) {
            $(".seller-location-details").removeClass("open");

            var index = this.data.locationId;
            var $location = $("#location-" + index);

            $("#locations-list").scrollTop(0);
            $("#locations-list").css({ overflow: "hidden" });

            var verticalPosition = $(location).scrollTop();

            $("#location-" + index)
              .find(".seller-location-details")
              .css("top", verticalPosition)
              .addClass("open");
          },
          annotation
        );

        map.addAnnotation(annotation);
      });

      var centerLat = data[0].lat;
      var centerLng = data[0].long;
      var center = new mapkit.Coordinate(centerLat, centerLng);
      var span = new mapkit.CoordinateSpan(0.125, 0.125);
      var region = new mapkit.CoordinateRegion(center, span);
      map.setRegionAnimated(region, true);
    });

    xhr.fail(function () {
      alert("An unexpected error occurred.");
    });

    xhr.always(function () {
      // Hide loading pane
      $("#beer-finder-loading").css({ display: "none" });
    });
  }

  function mapCommonTermToBrand(search) {
    return brandMap[search] || search;
  }

  $("#search-form").submit(function (e) {
    e.preventDefault();
    var searchTerm = $("#search-input").val();
    var query = {};
    var newZip = searchTerm.match(/\d{5}/g, "");

    // If the user previously searched with a zip, reapply it
    if (zip) {
      query.zip = zip;
    }

    // If there's something that looks zip-like, strip it from the search term
    // and assume the rest of it is a brand name
    if (newZip) {
      zip = newZip[0];
      query.zip = zip;

      if (zip !== searchTerm) {
        query.brand = searchTerm.replace(new RegExp(zip, "g"), "").trim();
      }
    } else {
      // No zip in the search, assume it was a brand search
      query.brand = searchTerm;
    }

    if (!query.zip) {
      query.lat = position.lat;
      query.lng = position.lng;
    }

    if (query.brand) {
      query.brand = mapCommonTermToBrand(query.brand.toLowerCase());
    }

    window.history.replaceState(
      "?" + jQuery.param(query),
      "Beer Finder | Braxton Brewing Company",
      "?" + jQuery.param(query)
    );
    search(query);
  });

  $(document).on("click", ".seller-location", function (e) {
    $("#locations-list").scrollTop(0);

    $(".seller-location-details").removeClass("open");
    $("#locations-list").css({ overflow: "hidden" });

    var $this = $(this);
    var locationIndex = $this.data("index");
    var locationData = $this.data("location");
    var marker = map.annotations.find(function (annotation) {
      return annotation.data.locationId == locationIndex;
    });

    map.annotations.forEach((annotation) => (annotation.selected = false));

    marker.selected = true;

    var verticalPosition = $(this).scrollTop();

    $(this)
      .find(".seller-location-details")
      .css("top", verticalPosition)
      .addClass("open");
  });

  $(document).on("click", ".seller-location-details-close", function (e) {
    e.stopPropagation();
    $(this).parent().removeClass("open");
    $("#locations-list").css({ overflow: "auto" });
    map.annotations.forEach((annotation) => (annotation.selected = false));
  });

  zip = getParameterByName("zip");
  brand = getParameterByName("brand");

  if (zip || brand) {
    var initialQuery = {};

    if (zip) {
      initialQuery.zip = zip;
    }
    if (brand) {
      initialQuery.brand = brand;
    }

    $("#search-input").val([zip, brand].join(" "));
    search(initialQuery);
  } else if (navigator.geolocation) {
    navigator.geolocation.getCurrentPosition(
      function (pos) {
        position = {
          lat: pos.coords.latitude,
          lng: pos.coords.longitude,
        };

        var center = new mapkit.Coordinate(
          pos.coords.latitude,
          pos.coords.longitude
        );
        var span = new mapkit.CoordinateSpan(0.0125, 0.0125);
        var region = new mapkit.CoordinateRegion(center, span);

        map.setRegionAnimated(region, true);

        // Geolocation available, search via lat/long
        search(position);
      },
      function (error) {
        // If geolocation is available but denied
        zip = "41011";
        search({ zip: zip });
      }
    );
  } else {
    // No geolocation available, default to 41011 zip search
    zip = "41011";
    search({ zip: zip });
  }

  $(function () {
    $("#beer-finder-button").click(function (e) {
      e.preventDefault();
      $("#beer-finder-info").toggleClass("close");
      $("#beer-finder-blocker").toggleClass("close");
    });

    // close intro from black background
    $("#beer-finder-blocker").click(function (e) {
      e.preventDefault();
      $(this).toggleClass("close");
      $("#beer-finder-info").toggleClass("close");
    });

    //reopen the help text area
    $("#help-button").click(function (e) {
      e.preventDefault();
      $("#beer-finder-info").toggleClass("close");
      $("#beer-finder-blocker").toggleClass("close");
    });
  });
})();
